import { h } from 'preact';

export function IconDoNotEnter({ width = 56, height = 56, fill = '#d92d20', barFill = '#fff' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 640 640"
      class="icon-do-not-enter"
    >
      <path
        d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM192 288L448 288C465.7 288 480 302.3 480 320C480 337.7 465.7 352 448 352L192 352C174.3 352 160 337.7 160 320C160 302.3 174.3 288 192 288z"
        fill={fill}
      />
      <path
        d="M160 320C160 302.3 174.3 288 192 288L448 288C465.7 288 480 302.3 480 320C480 337.7 465.7 352 448 352L192 352C174.3 352 160 337.7 160 320z"
        fill={barFill}
      />
    </svg>
  );
}
